import { Button, Grid } from "../../../components";

const ButtonMenu = ({ selectionModel, handleRegistrarEvento }) => {
  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="start"
      className="m-1 mx-3"
      gap={3}
    >
      <Button
        variant="contained"
        disabled={!selectionModel.length}
        onClick={handleRegistrarEvento}
      >
        <i
          className="ph-bold ph-upload-simple"
          style={{
            fontSize: 18,
            marginRight: 8,
            color: selectionModel.length ? "white" : "gray",
          }}
        ></i>
        Registrar Evento
      </Button>
    </Grid>
  );
};

export default ButtonMenu;
